// Shared preview-type detection for the preview panel and the store.
// One source of truth so the store only downloads what the panel can render.

export type PreviewKind =
  | 'office' // docx/xlsx/pptx (+ legacy doc/xls/ppt) - server-rendered via Graph preview
  | 'pdf' // server-rendered via Graph preview
  | 'image'
  | 'video'
  | 'audio'
  | 'eml' // parsed client-side into the email view
  | 'msg' // no reliable browser renderer - download only
  | 'text'
  | 'other';

const OFFICE_RE = /\.(docx?|xlsx?|pptx?)$/i;
const IMAGE_RE = /\.(png|jpe?g|gif|webp|bmp|svg|ico)$/i;
const VIDEO_RE = /\.(mp4|webm|ogg|mov)$/i;
const AUDIO_RE = /\.(mp3|wav|m4a|aac|flac)$/i;
const TEXT_RE =
  /\.(txt|md|csv|tsv|json|xml|html?|log|js|ts|jsx|tsx|css|scss|ya?ml|ini|cfg|conf|sql|py|ps1|sh|bat)$/i;

export function getPreviewKind(fileName: string): PreviewKind {
  const name = fileName.toLowerCase();
  if (name.endsWith('.eml')) return 'eml';
  if (name.endsWith('.msg')) return 'msg';
  if (name.endsWith('.pdf')) return 'pdf';
  if (OFFICE_RE.test(name)) return 'office';
  if (IMAGE_RE.test(name)) return 'image';
  if (VIDEO_RE.test(name)) return 'video';
  if (AUDIO_RE.test(name)) return 'audio';
  if (TEXT_RE.test(name)) return 'text';
  return 'other';
}
